// import Vue from 'vue';
import imageService from '../../api/image-service';
import { removeArrayItem, reorderSequenceByIndex } from '../../util/array';
import eventBus, { OPEN_SNACKBAR, openConfirmDialog } from '../../util/event-bus';
import i18n from '../../i18n/i18n-config';

const state = {
  images: {
    friend_logo: [],
    partner_logo: [],
    slider: [],
    training: [],
  },
  loadingImages: false,
  savingImage: false,
};

const mutations = {
  SET_IMAGES(state, data) {
    const map = { ...state.images };
    for (let i = 0; i < data?.length; i++) {
      if (map[data[i].type]) {
        map[data[i].type].push(data[i]);
      } else {
        map[data[i].type] = [data[i]];
      }
    }
    state.images = map;
  },

  STORE_IMAGES(state, { images, type }) {
    state.images[type] = [...state.images[type], ...images];
  },

  REORDER_IMAGES(state, { oldIndex, newIndex, type }) {
    state.images[type] = reorderSequenceByIndex(state.images[type], oldIndex, newIndex);
  },

  DELETE_IMAGE(state, { image, type }) {
    state.images[type] = removeArrayItem(state.images[type], image);
  },

  SET_SAVING_IMAGES(state, saving) {
    state.savingImage = saving;
  },

  SET_LOADING_IMAGES(state, loading) {
    state.loadingImages = loading;
  },
};

const actions = {
  fetchImages({ commit }, params) {
    commit('SET_LOADING_IMAGES', true);
    return imageService
      .getImages(params)
      .then((res) => {
        commit('SET_IMAGES', res.data);
      })
      .finally(() => {
        commit('SET_LOADING_IMAGES', false);
      });
  },

  async uploadImages({ commit }, { images, type }) {
    commit('SET_SAVING_IMAGES', true);
    eventBus.$emit(OPEN_SNACKBAR, {
      text: i18n.t('uploading'),
      showProgress: true,
      timeout: -1,
    });
    const res = await imageService.upload(images, type);
    commit('SET_SAVING_IMAGES', false);
    commit('STORE_IMAGES', { images: res.data, type });
    eventBus.$emit(OPEN_SNACKBAR, i18n.t('image_uploaded'));
    return res;
  },

  reorderImages({ commit }, { oldIndex, newIndex, type }) {
    const oldImages = JSON.parse(JSON.stringify(state.images));
    const movedItem = oldImages[type][oldIndex];
    commit('REORDER_IMAGES', { oldIndex, newIndex, type });
    return imageService
      .reorderImages({
        id: movedItem.id,
        type: movedItem.type,
        sequence: state.images[type][newIndex].sequence,
      })
      .catch(() => {
        commit('SET_IMAGES', oldImages);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('reorder_error'));
      });
  },

  deleteImage({ commit }, { image, type }) {
    openConfirmDialog({
      title: i18n.t('confirm_image_delete'),
    }).then((confirmed) => {
      if (!confirmed) {
        return;
      }
      imageService.delete(image).then(() => {
        commit('DELETE_IMAGE', { image, type });
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('image_deleted'));
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
